import { RadioGroup } from '@material-ui/core';
import styled from 'styled-components';
import { _ellipsis } from 'theme/_mixins/mixins';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

export const Card = styled.div`
  width: 100%;
  margin: 8px 16px;
  display: flex;
  border-radius: 8px;
  box-shadow: 0 6px 10px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);
  background: ${({ theme }) => theme.cardFlight.background};
  min-width: 250px;
  flex-direction: column;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 8px 0;
    flex-direction: row;
  }
`;

export const FlightsContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  > * + * {
    border-top: 0.5px solid ${ColorPalette.HEX.Platinum2};
  }

  @media ${({ theme }) => theme.device.desktop} {
    border-right: 0.5px solid ${ColorPalette.HEX.Platinum2};
  }
`;

export const FlightsWrapper = styled.div`
  padding: 12px;

  @media ${({ theme }) => theme.device.desktop} {
    padding: 16px;
  }
`;

export const RouteTypeHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(32, minmax(0, 1fr));
  align-items: end;
`;

export const RouteTypeRoot = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 12 / span 12;
`;

export const RouteTypeWrapper = styled.div`
  display: flex;
`;

export const RouteTypeText = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${ColorPalette.HEX.PineTree};
  margin-left: 4px;
`;

export const RouteTypeStartAirportContainer = styled.div`
  grid-column: span 6 / span 6;
`;

export const RouteTypeEndAirportContainer = styled.div`
  grid-column: span 9 / span 9;
`;

export const RouteTypeDate = styled.span`
  font-size: 12px;
  line-height: 1.5;
  color: ${ColorPalette.HEX.DimGray2};
`;

export const Summary = styled.div`
  width: 188px;
  display: flex;
  flex-direction: column;
  padding: 24px;
  text-align: right;
`;

export const RouteTypeHeaderText = styled.span`
  font-size: 12px;
  line-height: 1.5;
  color: ${ColorPalette.HEX.DimGray2};
`;

export const RouteTypeCityName = styled(RouteTypeHeaderText)`
  ${_ellipsis()};
  margin-top: 3px;
  width: 100px;
`;

export const FlightLuggages = styled.div`
  display: flex;

  > * + * {
    margin-left: 1px;
  }
`;

export const FlightLuggagesContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TooltipContainer = styled.div`
  padding : 0px !important; 
`;

export const Restrictions = styled.p`
  font-size: 12px;
  color: ${ColorPalette.HEX.DimGray2};
  margin-left: 55px;
`;

export const FlightsListContainer = styled(RadioGroup)`
  margin-top: 16px;

  @media ${({ theme }) => theme.device.desktop} {
    margin-top: 32px;
  }

  > * + * {
    margin-top: 16px;
  }
`;

export const FinalPriceWithTaxes = styled.span`
  font-size: 12px;
  line-height: 1.33;
  text-align: right;
  color: ${ColorPalette.HEX.DimGray2};
  margin-top: 4px;
`;

export const PriceContainer = styled.div``;

export const DiscountWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Discount = styled.span`
  font-size: 12px;
  font-weight: 600;
  line-height: 1.33;
  text-align: right;
  color: ${ColorPalette.HEX.VioletRYB};
`;

export const OriginalPrice = styled.span`
  font-family: Poppins;
  font-size: 12px;
  line-height: 1.33;
  text-align: right;
  color: ${ColorPalette.HEX.DimGray2};
  text-decoration: line-through;
  margin-left: 4px;
`;

export const PriceWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Price = styled.span`
  margin-left: 4px;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.83px;
  text-align: right;
  color: ${ColorPalette.HEX.PineTree};
`;

export const Currency = styled.span`
  margin: 8px 0 4px 2px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.33;
  text-align: right;
  color: ${ColorPalette.HEX.PineTree};
`;

export const AlternativePrice = styled.span`
  margin-left: 4px;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.83px;
  text-align: right;
  color: ${ColorPalette.HEX.PineTree};
`;

export const AlternativeCurrency = styled.span`
  margin: 8px 0 4px 2px;
  font-size: 10px;
  font-weight: 400;
  line-height: 1.33;
  text-align: right;
  color: ${ColorPalette.HEX.PineTree};
`;

export const Cashback = styled.span`
  margin-top: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.33;
  text-align: right;
  color: ${ColorPalette.HEX.VioletRYB};
`;

export const ConfirmButton = styled(Button)`
  height: 40px;
  width: 100%;
  font-size: 12px;
  font-weight: 600;
  border-width: 0;
  margin-top: 24px;
  border-radius: 8px;
  padding: 0 12px !important;
`;

export const ButtonHelperText = styled.span`
  margin-top: 8px;
  font-size: 10px;
  text-align: right;
  color: ${ColorPalette.HEX.DimGray2};
  line-height: normal;
`;

export const FlightTimeContainer = styled.div`
  display: flex;
  align-items: center;
  grid-column: span 4 / span 4;
  justify-content: space-between;
`;

export const SummaryMobile = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 12px;
  border-top: 0.5px solid ${ColorPalette.HEX.Platinum2};
`;

export const ConfirmButtomMobile = styled(ConfirmButton)`
  width: 130px;
  margin: 10px;
  height: 54px;
`;

export const FinalPriceWithTaxesMobile = styled.span`
  color: ${ColorPalette.HEX.PhilippineGray};
  font-size: 12px;
  text-align: right;
`;

export const BreakRulesMessage = styled.span`
  font-size: 13px;
  line-height: 1.33;
  text-align: right;
  color:  ${ColorPalette.HEX.RedRYB};
  margin-top: 4px;
`;

export const NoBreakRulesMessage = styled.span`
  font-size: 13px;
  line-height: 1.33;
  text-align: right;
  color: ${ColorPalette.HEX.GreenPantone};
  margin-top: 4px;
`;

export const ConfirmUpSellButton = styled(Button)`
  height: 60px;
  width: 100%;
  font-size: 12px;
  font-weight: 600;
  border-width: 0;
  margin-top: 24px;
  border-radius: 8px;
`;

export const FooterMobile = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ConfirmUpSellButtomMobile = styled(Button)`
  width: 100%;
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  border-width: 0;
  border-radius: 8px;
`;
